import {Component, Input, OnInit} from '@angular/core';
import {Line} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";


@Component({
  selector: 'app-line-setting-text',
  templateUrl: './line-setting-text.component.html',
  styleUrls: ['./line-setting-text.component.css']
})
export class LineSettingTextComponent implements OnInit {
  @Input()  line: Line = new Line();
  itemValue: &VariableValue = new VariableValue();


  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(value:VariableValue): string
  {
    return sprintf("%5.1f", value.val / 1);
  }

  ngOnInit(): void {
    this.itemValue = this.variableDB.AddValueByReference(this.line.variable.id);
  }

  GetText(value:VariableValue): string {
        return this.line.textvalues[value.val].text;
  }


}
